import { StepsButton } from "./components/stepsButton";
import { currencyFormatter } from "../../../utils/helpers";

// import { useRecoilState, useRecoilValue } from "recoil";
import { purchaseRequestSmartcardsState } from "./atoms/atoms";
import { CreateDSTVPurchaseRequest } from "../../../../domain/usecases";
import Loading from "../../../components/loading/loading";
import { useRecoilValue } from "recoil";
import { format } from "date-fns";

type Props = {
  createDSTVPurchaseRequest: CreateDSTVPurchaseRequest;
};

export default function ConfirmDSTVPurchaseRequest({
  createDSTVPurchaseRequest,
}: Props) {
  const state = useRecoilValue(purchaseRequestSmartcardsState);
  // const [state, setState] = useRecoilState(purchaseRequestSmartcardsState);

  // payload = locations.filter((c) => c !== location);
  const smartcardList = state.smartcards.filter((smartcard) => {
    return +smartcard.purchaseAmount > 0;
  });

  return (
    <>
      <div className="w-full">
        <div className="flex flex-col">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-1 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="pb-8 overflow-hidden">
                <table className="min-w-full bg-gray-50 border rounded-sm border-gray-200">
                  <thead className="sticky bg-gray-200">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-sm font-medium text-gray-600 tracking-wide"
                      >
                        <div>Smartcard Name &amp;</div>
                        <div>Location</div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-sm font-medium text-gray-600 tracking-wide"
                      >
                        <div>Smartcard Number &amp;</div>
                        <div>Registered Owner</div>
                      </th>

                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-sm font-medium text-gray-600 tracking-wide"
                      >
                        Last Purchase &amp; Amount
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-sm font-medium text-gray-600 tracking-wide"
                      >
                        Purchase Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {smartcardList.map((smartcard, smartcardIdx) => (
                      <tr
                        key={smartcard.id}
                        className="border-b border-gray-150"
                      >
                        <td className="px-6 py-1 whitespace-nowrap text-sm font-normal">
                          <div className="text-sm text-gray-500">
                            {smartcard.location}
                          </div>
                        </td>
                        <td className="px-6 py-1 whitespace-nowrap">
                          <div className="text-sm font-medium text-gray-900">
                            {smartcard.name}
                          </div>
                          <div className="text-sm text-gray-500">
                            {smartcard.number}
                          </div>
                        </td>

                        <td className="px-6 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
                          {smartcard.lastPurchaseDate === "None"
                            ? "None"
                            : format(
                                new Date(smartcard.lastPurchaseDate),
                                "yyyy-MM-dd"
                              )}
                          &nbsp; &mdash; &nbsp;
                          {currencyFormatter(smartcard.lastPurchaseAmount)}
                        </td>
                        <td className="px-6 py-1 whitespace-nowrap text-sm text-gray-500">
                          <span className="text-gray-900 font-bold">
                            {currencyFormatter(smartcard.purchaseAmount)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <StepsButton
          createDSTVPurchaseRequest={createDSTVPurchaseRequest}
          step="confirm"
          isEnabled={true}
          primaryText="Submit Request"
          secondaryText="   Back   "
        />
      </div>

      {state.isLoading && <Loading />}
    </>
  );
}
